/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import ActionTypes from './actionTypes'

export const headerAction = (payload) => (dispatch) =>
  dispatch({
    type: ActionTypes.HEADER,
    payload,
  })
